import React from 'react';
import PropTypes from 'prop-types';

import { Button } from "react-bootstrap";

import ModalComponent from '../ModalComponent';

const FeeEntityDeletionModal = ({ closeModal, submitTrigger, deletionMsg }) => {

  return (
    <ModalComponent
      onClose={() => closeModal()}
      className={'fee-group-modal'}
      title={'Are you sure?'}
      buttons={
        [
          <Button
            variant={'danger'}
            onClick={() => submitTrigger()}
          >Confirm</Button>
        ]
      }
    >
      <p>
        {deletionMsg}
      </p>
    </ModalComponent>
  )
}

FeeEntityDeletionModal.propTypes = {
  submitTrigger: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  deletionMsg: PropTypes.string
};

export default FeeEntityDeletionModal;